'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getItemDescriptionId = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _reselect = require('reselect');

var _modal = require('./modal');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* reducer */
var DEFAULT_STATE = {
    itemId: 0
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _modal.OPEN_ITEM_DESCRIPTION_MODAL:
            return (0, _extends3.default)({}, state, {
                itemId: action.payload
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.itemDescription;
};

var getItemDescriptionId = exports.getItemDescriptionId = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.itemId;
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/itemDescription.js
// module id = IVRy
// module chunks = 57